<template>
  <div class="member-message" :class="$style.container">
    <div class="member-message__author" v-show="!message.redacted_because && message.type !==  $options.eventTypes.redaction" v-if="!!members.length">
      <avatar :size="20" :user="{firstName: getUserProfileById(message.sender).name.toUpperCase(), avatarLink: getUserProfileById(message.sender).avatar}"/>
      <b>{{ getUserProfileById(message.sender).name }}</b>
    </div>
    <template v-if="message.type ===  $options.eventTypes.message || message.type ===  $options.eventTypes.redaction">
      <div style="display: flex;justify-content: flex-start; align-items: center;">
        <svg aria-hidden="true" style="margin-right: 3px;" focusable="false" data-prefix="fas" color="currentColor" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash-alt fa-w-14"><path fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" class=""></path></svg>
        <span>
        {{ $t('messageDeletedBy') }} <b>{{ message.redacted_because && getUserProfileById(message.redacted_because.sender).name || getUserProfileById(message.sender).name }}</b>
      </span>
      </div>
    </template>
    <template v-else-if="message.type === $options.eventTypes.name">
      {{ $t('changeChatName') }} <b>{{ message.content.name }}</b>
    </template>
    <template v-else-if="message.type === $options.eventTypes.avatar">
      {{ $t('changeChatAvatar') }}
      <avatar :size="20" :user="{avatarLink: createLinkImage(message.content.url)}" style="margin-left: 5px"/>
    </template>
    <template v-if="message.type === $options.eventTypes.member">
      <template v-if="message.content.membership === $options.selfMembershipTypes.invite && message.content.displayname">
        {{ $t('invite') }}
        <avatar :size="20" style="margin-left: 7px;" :user="{firstName: formattedUserName(message.content.displayname).toUpperCase(), avatarLink: createLinkImage(message.content.avatar_url)}"/>
        <b style="margin: 0 5px;">{{ formattedUserName(message.content.displayname) }}</b>
      </template>
      <template v-if="message.content.membership === $options.selfMembershipTypes.leave">
        {{ $t('kick') }}
        <b>{{ message.state_key.slice(1).split(':')[0] }}</b>
      </template>
      <template v-if="message.content.membership === $options.selfMembershipTypes.join">
        {{ $t('joinChat') }}
      </template>
    </template>
  </div>
</template>

<script>

import Avatar from '@/components/Avatar'
import { createLinkImage, formattedUserName } from '@/helpers'
import { mapGetters } from 'vuex'
import { eventTypes, selfMembershipTypes } from '@/helpers/variables'

export default {
  name: 'event-message',
  eventTypes,
  selfMembershipTypes,
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  components: {
    Avatar
  },
  computed: {
    ...mapGetters({
      members: 'matrix/roomMembers'
    })
  },
  methods: {
    formattedUserName,
    createLinkImage,
    async getUserImage (id) {
      const user = await window.matrixSDK.getUser(id)
      return createLinkImage(user.avatarUrl)
    },
    getUserProfileById (id) {
      const user = this.members.find(e => e.id === id)
      return {
        avatar: user ? user.avatar_url : '',
        name: user ? user.display_name : ''
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  padding-right: 16px;
}
.subject {
  font-size: 12px;
  font-weight: 500;
  color: $text-mid;
}
.showOriginal {
  margin-left: 2px;
  font-size: 10px;
  color: $text-colored;
  &:hover {
    text-decoration: underline;
  }
}
</style>
<style lang="scss">
.member-message{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  &__author{
    margin-right: 4px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    b{
      padding-left: 5px;
    }
  }
}

</style>
